import * as React from "react";
import {Component } from "react";

import "./header.scss";

import {Search} from "../../../core/components/search/search";
import {SearchConfiguration} from "../../../core/config/search-configuration";

import {Button, Menu, Popup as SemanticPopup} from "semantic-ui-react";

import {Title} from "../../../core/components/title/title";
import {observer} from "mobx-react";
import {MapFinder} from "../../../core/components/map-finder/map-finder";
import {Icon} from "../../../core/components/icon/icon";
import MediaQuery from "react-responsive";
import {runInAction} from "mobx";
import {TopicSwitcherButton} from "../../../core/components/topic-switcher/topic-switcher-button";
import logo from "../../../assets/images/kt_logo_white_inverted.svg";
import SVG from "react-inlinesvg";
import {IAppStore, withStore} from "../../../core/stores/abstract-app-store";

export interface HeaderProps {
    capabilities: string[];
    searchConfig?: SearchConfiguration;  // widgetsSearch is also the type for configuration object
    store?: IAppStore; // this is injected by withStore
}

@observer
export class HeaderBase extends Component<HeaderProps, any> {

    constructor(props: HeaderProps) {
        super(props);
        this.state = {
            search: null
        };
    }
    toggleSidebarVisible(): void {
        const {store} = this.props;
        runInAction(()=> {
            store?.uiStore.setSidebarVisible(!store?.uiStore.sidebarVisible);
        });
    }
    render(): JSX.Element | null {
        const {searchConfig, store} = this.props;
        if (!store) {
            return null;
        }

        const mode = store.appConfig.mode;
        const {topic, subtopic, objectLabel} = store.appStore;
        if (!topic) {
            return null;
        }

        let aboutLink: JSX.Element | undefined;
        if (store.mapViewerConfig.aboutLink) {
            aboutLink = (
                <a href={store.mapViewerConfig.aboutLink.url} rel={"noreferrer"}
                    target={"_blank"} className={"geo-about-link"}>
                    {store.mapViewerConfig.aboutLink.title}</a>
            );
        }
        let helpLink: JSX.Element | undefined;
        if (store.mapViewerConfig.helpLink) {
            helpLink = (<div className={"geo-help-link"}>
                <SemanticPopup
                    content={store.mapViewerConfig.helpLink.title}
                    trigger={<Button href={store.mapViewerConfig.helpLink.url} as={"a"} rel={"noreferrer"}
                        target={"_blank"}>
                        <Icon name={"question"}/></Button>}
                    on={"hover"}/></div>
            );
        }
        return(
            <div className={"geo-app-header"}>
                <Title
                    siteTitle={(subtopic?.name?
                        (objectLabel? objectLabel+" - ":"") + subtopic.name + " - " :"") + topic.label}
                    pageTitle={store.mapViewerConfig.title}
                    topic={topic}
                    subtopic={subtopic}/>
                <Menu attached="top" inverted>
                    <div className={"geo-logo"}>
                        <Menu.Item>
                            <a href={"https://geoportal.lu.ch"} target="_blank" rel={"noreferrer"}>
                                <SVG src={logo} height={28} width={94}/>
                                {(mode !== "production")? (
                                    <span className="geo-badge geo-test-badge">Test</span>) : ""}</a>
                        </Menu.Item>
                    </div>
                    <MediaQuery maxWidth={store.mapViewerConfig.breakpoints.md}>
                        <Menu.Item className={"geo-map-mobile-menu"}>
                            <Button onClick={() => this.toggleSidebarVisible()}>
                                <span className="header__mobilenavigation-button-text">Navigation</span>
                            </Button>
                        </Menu.Item>
                    </MediaQuery>
                    {(store.mapViewerConfig.subtopics
                        && Array.isArray(store.mapViewerConfig.topicSwitcher?.visible)
                        && store.mapViewerConfig.topicSwitcher.visible.includes("header"))?<TopicSwitcherButton
                            topics={store.mapViewerConfig.subtopics}
                            showTopic={true}
                        />: <h1><span>{topic.label}</span>{aboutLink}</h1>}
                    <Menu.Menu position="right">
                        <MediaQuery minWidth={(store.mapViewerConfig.breakpoints.md + 1)}>
                            {helpLink}
                            <Menu.Item className={"geo-map-finder"}>
                                <MapFinder />
                            </Menu.Item>
                        </MediaQuery>
                        {this.props.capabilities.map((cap) => {
                            if (cap === "search" && searchConfig) {
                                return (
                                    <Search
                                        key={cap}
                                        config={searchConfig}
                                        tracker={store.mapViewerConfig?.tracker? store.appStore.tracker: undefined}
                                    />
                                );
                            }
                        })}
                    </Menu.Menu>
                </Menu>
            </div>
        );
    }
}

export const Header = withStore(HeaderBase);
